// extracted by mini-css-extract-plugin
module.exports = {"clear-border":"#b2b5b8","clear-gray-interaction":"#ececec","clear-gray-interaction-shadow":"#428bca","clear-gray-disabled":"#e6e6e6","clearButton":"ClearButton_clearButton__KJPYK"};